const host_url = process.env.REACT_APP_HOST_URL
import toast from 'react-hot-toast'
import { isBeforeBusinessToday } from '../utils/businessDate'

/**
 * Sanitizes URL parameters by converting null, undefined, or 'null' string values to empty strings
 * @param {*} value - The value to sanitize
 * @returns {string} - The sanitized value
 */
function sanitizeUrlParam(value: any) {
   if (value === null || value === undefined || value === 'null') {
      return ''
   }
   return value
}

// Interface removed as we're now using individual parameters

export default async function generatePDF(
   opportunity_id: string,
   formType: number,
   account_name: string,
   opportunity_name: string,
   opportunity_contact_name: string,
   opportunity_contact_email: string,
   last_agent_email: string,
   last_agent_name: string,
   invoice_number: string,
   monthly_cost: number,
   due_at_activation: number,
   calculated_values: any,
   user_role: string,
   server_today?: string | null,
) {
   // Get expiration date from calculated_values
   const expiration_date = calculated_values?.expiration_date || ''
   const toastId = toast.loading('Saving PDF to Opportunity')
   // Noon local avoids the display date shifting across timezones
   const exp_date = new Date(expiration_date + 'T12:00:00')
   if (
      expiration_date &&
      isBeforeBusinessToday(expiration_date, server_today)
   ) {
      toast.error(
         `Unable to save to opportunity due to expired quote with an expiration date of ${exp_date.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}.\nPlease update the quote expiration date and try again.`,
         { id: toastId, duration: 5000 },
      )
      return
   }
   try {
      // Encode opportunity_name and account_name to prevent special characters from breaking the URL
      const encodedOpportunityName = encodeURIComponent(opportunity_name)
      const encodedAccountName = encodeURIComponent(account_name)

      // Sanitize all URL parameters to handle null values
      const sanitizedFormType = sanitizeUrlParam(formType)
      const sanitizedOpportunityId = sanitizeUrlParam(opportunity_id)
      const sanitizedOpportunityContactName = sanitizeUrlParam(
         opportunity_contact_name,
      )
      const sanitizedOpportunityContactEmail = sanitizeUrlParam(
         opportunity_contact_email,
      )
      const sanitizedLastAgentEmail = sanitizeUrlParam(last_agent_email)
      const sanitizedLastAgentName = sanitizeUrlParam(last_agent_name)
      const sanitizedInvoiceNumber = sanitizeUrlParam(invoice_number)
      const sanitizedMonthlyCost = sanitizeUrlParam(monthly_cost.toString())
      const sanitizedDueAtActivation = sanitizeUrlParam(
         due_at_activation.toString(),
      )
      const sanitizedUserRole = sanitizeUrlParam(user_role)

      let response = await fetch(
         `${host_url}/api/pdf?form_type=${sanitizedFormType}&opportunity_id=${sanitizedOpportunityId}&account_name=${encodedAccountName}&opportunity_name=${encodedOpportunityName}&opportunity_contact_name=${sanitizedOpportunityContactName}&opportunity_contact_email=${sanitizedOpportunityContactEmail}&last_agent_email=${sanitizedLastAgentEmail}&last_agent_name=${sanitizedLastAgentName}&invoice_number=${sanitizedInvoiceNumber}&monthly_cost=${sanitizedMonthlyCost}&due_at_activation=${sanitizedDueAtActivation}&user_role=${sanitizedUserRole}`,
         {
            method: 'POST',
            headers: {
               Accept: 'application/json',
               'Content-Type': 'application/json',
            },
            body: JSON.stringify(calculated_values),
         },
      )
      if (response.ok) {
         toast.success(
            opportunity_id.substring(0, 4) == 'ACC-'
               ? 'Saved PDF to Account'
               : 'Saved PDF to Opportunity',
            { id: toastId, duration: 1500 },
         )
      } else {
         toast.error(
            opportunity_id.substring(0, 4) == 'ACC-'
               ? 'Error Saving PDF to Account\n' + (await response.text())
               : 'Error Saving PDF to Opportunity\n' + (await response.text()),
            { id: toastId, duration: 5000 },
         )
      }
   } catch (e: any) {
      toast.error(
         opportunity_id.substring(0, 4) == 'ACC-'
            ? 'Unable to save to Account due to error\n' + e.message
            : 'Unable to save to Opportunity due to error\n' + e.message,
         { id: toastId, duration: 5000 },
      )
   }
}
